import React from 'react';
import { Box, ChevronRightIcon, Inscription } from '@common-fe/common-fe';

import { Changeset } from '@/modules/ActivityLog/LogList/LogItem/Changeset/common';

interface LogChangeProps {
  testId?: string;
  logChange: Changeset;
}

const LogChange: React.FC<LogChangeProps> = ({ testId, logChange }) => (
  <Box key={logChange?.id} direction="row" pad={{ bottom: 'spacing8' }}>
    <Box width="206px">
      <Inscription data-testId={`${testId}_attribute`} size="14px" lineHeight="20px" color="textBody">
        {logChange?.attribute}:
      </Inscription>
    </Box>
    <Box>
      <Inscription data-testId={`${testId}_previous-value`} color="textBody" weight="bold" lineHeight="20px">
        {logChange?.previous || <Inscription>–</Inscription>}
      </Inscription>
    </Box>
    <Box justify="center" margin={{ horizontal: 'spacing8' }}>
      <ChevronRightIcon size="8px" color="textSecondary" />
    </Box>
    <Box>
      {logChange?.updatedNode ? logChange?.updatedNode : (
        <Inscription data-testId={`${testId}_updated-value`} color="textBody" weight="bold" lineHeight="20px">
          {logChange?.updated || <Inscription>–</Inscription>}
        </Inscription>
      )}
    </Box>
  </Box>
);

export default LogChange;
